import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
//import './sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import CardWrap from '../../microservice/components/CardWrapper';
// import config from '../components/config';
import '../../container/Box/Components/Box-Style.css'
import Sidebar from '../../container/Sidebar/Sidebar';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-en';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import SidebarEn from '../../container/Sidebar/Sidebar-en';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;
// Titlecloudcompute
function SimpleUrlENG() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Simple-Url-Shortener - Serverless Application - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarEn />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Simple-Url-Shortener")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">What is a Simple URL Shortener?</p></BoxTitle>

                            <BoxText  >
                                <p class="typo-14">It converts long web addresses containing many characters, symbols, and numbers into shorter URLs using PURLs.</p>
                                <p class="typo-14">(Example) <u>abc.vora.net/desk/marketing/survey.html?id=a3bc65cd</u> </p>
                                <p class="typo-14">- Using a default domain: =&gt; sus.so/aB2b3Aza </p>
                                <p class="typo-14">- Using your company's domain: =&gt; 자사도메인/aB2b3Aza </p>
                                <br></br>
                                <p class="typo-14">It provides short, easy-to-read URLs based on standard websites, maintaining recognizability of previous URLs.</p>
                                <p class="typo-14">- Using a default domain: =&gt; sus.so/brandname/uniquekeyword (e.g., help, sales, marketing, etc.) </p>
                                <p class="typo-14">- Using your company's domain: =&gt; customdomain/uniquekeywordn(e.g., help, sales, marketing, etc.) </p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">PURLs (Personalized URLs)</p></BoxTitle>
                            <BoxText  >
                                <p class="typo-14">- During marketing campaigns, tailored web URLs and content are delivered to each individual target.</p>
                                <p class="typo-14">- Each PURL is a unique, personalized website link.</p>
                                <p class="typo-14">- When personalized texts, images, offers, surveys, and other content are delivered, marketing teams can track responses and engagement in real time.</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        {/* {CardWrap("<p class='typo-21 typo-medium typo-black'>Email / SMS 마케팅시 단축 URL 사용 예</p>", "", "", "https://hanbiro.com/cloud/library2/simple-url-shortener/simple-url-shortener-1.svg")} */}
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Example of Using Shortened URLs in Email / SMS Marketing</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/simple-url-shortener-1.png"></ImageWrap>
                        </BoxContent>
                        {/*CardWrap("• 가격",config.tb8_header,config.tb8_content)*/}

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>

            <FooterEn />
        </Sysfont>
    );
};

const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const BoxSubText = styled.div`
  margin-left: 7%;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`
export default SimpleUrlENG;